module.exports = __webpack_public_path__ + "img/down-arrow.17415060.svg";